import { c as _c } from "react/compiler-runtime";
import { Drawer } from '@mui/material';
import DrawerContent from './DrawerContent';
import DrawerHeader from './DrawerHeader';
import { config } from '../theme';
import { useMemo, use } from 'react';
import { LayoutContext } from '..';
const MainDrawer = t0 => {
  const $ = _c(16);
  const {
    unauthorized: t1
  } = t0;
  const unauthorized = t1 === undefined ? false : t1;
  const {
    isMobile,
    toggleDrawer,
    drawerOpen
  } = use(LayoutContext);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DrawerContent />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const drawerContent = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DrawerHeader />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const drawerHeader = t3;
  let t4;
  if ($[2] !== isMobile || $[3] !== toggleDrawer) {
    t4 = () => {
      if (isMobile) {
        toggleDrawer();
      }
    };
    $[2] = isMobile;
    $[3] = toggleDrawer;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const onClose = t4;
  let t5;
  if ($[5] !== isMobile || $[6] !== toggleDrawer) {
    t5 = e => {
      if (!isMobile) {
        return;
      }
      const target = e?.target;
      if (target?.getAttribute("role") === "button" || target?.nodeName === "SPAN") {
        toggleDrawer();
      }
    };
    $[5] = isMobile;
    $[6] = toggleDrawer;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const onClick = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      width: config.drawerWidth,
      flexShrink: 0,
      "& .MuiDrawer-paper": {
        width: config.drawerWidth,
        boxSizing: "border-box"
      }
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = isMobile ? "temporary" : "persistent";
  const t8 = drawerOpen && drawerHeader;
  const t9 = drawerOpen && !unauthorized && drawerContent;
  let t10;
  if ($[9] !== drawerOpen || $[10] !== onClick || $[11] !== onClose || $[12] !== t7 || $[13] !== t8 || $[14] !== t9) {
    t10 = <Drawer sx={t6} variant={t7} onClose={onClose} anchor="left" open={drawerOpen} onClick={onClick}>{t8}{t9}</Drawer>;
    $[9] = drawerOpen;
    $[10] = onClick;
    $[11] = onClose;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};
export default MainDrawer;